import * as echarts from 'echarts'
import de from 'echarts/i18n/langDE-obj'

echarts.registerLocale('de', de)

export default echarts
